import { render } from "./ChildOrgSelectionPanel.vue?vue&type=template&id=6a7e31bc"
import script from "./ChildOrgSelectionPanel.vue?vue&type=script&lang=js"
export * from "./ChildOrgSelectionPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__